import { useLang } from "../lib/i18n";
import { PageHeader } from "../components/ui-vision";

const CONTROLLER = ["COMEC BV", "Vision+", "Groot-Molenveldlaan 51 003", "1850 Grimbergen", "Belgique", "BE 0758.412.316", "info@vplus.be", "02 588 56 00"];

const FR = [
  { h: "Responsable du traitement", p: ["Les données personnelles collectées via le site sont traitées par :"], list: CONTROLLER },
  { h: "1. Données collectées", p: [
    "Vision+ peut collecter les informations que vous transmettez volontairement via les formulaires du site, notamment :",
  ], bullets: [
    "nom et prénom", "adresse e-mail", "numéro de téléphone", "adresse", "informations relatives à votre projet",
    "informations de rendez-vous", "informations de demande de devis", "toute information fournie volontairement dans un message ou un formulaire",
  ] },
  { h: "2. Finalités", p: ["Ces informations peuvent être utilisées pour :"], bullets: [
    "répondre à vos demandes", "traiter les demandes de devis", "organiser les rendez-vous",
    "contacter les clients ou prospects au sujet de leur demande", "préparer et suivre les projets clients",
    "assurer les communications administratives légitimes liées à une demande ou à la relation client",
  ] },
  { h: "3. Bases légales", p: [
    "Selon la situation, le traitement repose sur l'une des bases légales prévues par le RGPD : l'exécution de mesures précontractuelles prises à votre demande, l'exécution d'un contrat le cas échéant, les intérêts légitimes de Vision+ lorsqu'ils s'appliquent, ou le respect d'obligations légales lorsque cela est requis.",
  ] },
  { h: "4. Destinataires des données", p: [
    "Vos données personnelles sont destinées à Vision+ / COMEC BV. Elles peuvent également être traitées par des prestataires techniques lorsque cela est nécessaire au fonctionnement du site, aux communications ou à la fourniture du service demandé.",
  ] },
  { h: "5. Conservation", p: [
    "Les données personnelles sont conservées uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées et, le cas échéant, pendant les durées requises par les obligations légales ou administratives belges.",
  ] },
  { h: "6. Vos droits", p: [
    "Conformément au RGPD, vous disposez notamment des droits suivants : droit d'accès, de rectification, d'effacement, de limitation du traitement, d'opposition et de portabilité de vos données.",
    "Toute demande relative à vos données personnelles peut être adressée à info@vplus.be. Vous avez également le droit d'introduire une réclamation auprès de l'Autorité belge de protection des données.",
  ] },
  { h: "7. Sécurité", p: [
    "Des mesures techniques et organisationnelles raisonnables sont mises en œuvre afin de protéger vos données personnelles contre tout accès, perte ou utilisation non autorisés.",
  ] },
  { h: "8. Mises à jour", p: [
    "La présente politique de confidentialité peut être mise à jour lorsque cela s'avère nécessaire. La version publiée sur le site fait foi.",
  ] },
];

const NL = [
  { h: "Verwerkingsverantwoordelijke", p: ["De via de website verzamelde persoonsgegevens worden verwerkt door:"], list: CONTROLLER },
  { h: "1. Verzamelde gegevens", p: [
    "Vision+ kan de informatie verzamelen die u vrijwillig via de formulieren van de website verstrekt, met name:",
  ], bullets: [
    "naam en voornaam", "e-mailadres", "telefoonnummer", "adres", "informatie over uw project",
    "afspraakinformatie", "informatie voor een offerteaanvraag", "alle informatie die vrijwillig in een bericht of formulier wordt verstrekt",
  ] },
  { h: "2. Doeleinden", p: ["Deze informatie kan worden gebruikt om:"], bullets: [
    "op uw vragen te antwoorden", "offerteaanvragen te behandelen", "afspraken te organiseren",
    "klanten of prospecten te contacteren over hun aanvraag", "klantprojecten voor te bereiden en op te volgen",
    "legitieme administratieve communicatie met betrekking tot een aanvraag of klantrelatie te verzorgen",
  ] },
  { h: "3. Rechtsgronden", p: [
    "Afhankelijk van de situatie berust de verwerking op een van de door de AVG voorziene rechtsgronden: het nemen van precontractuele maatregelen op uw verzoek, de uitvoering van een overeenkomst indien van toepassing, de gerechtvaardigde belangen van Vision+ waar van toepassing, of de naleving van wettelijke verplichtingen waar vereist.",
  ] },
  { h: "4. Ontvangers van de gegevens", p: [
    "Uw persoonsgegevens zijn bestemd voor Vision+ / COMEC BV. Ze kunnen ook worden verwerkt door technische dienstverleners wanneer dit noodzakelijk is voor de werking van de website, de communicatie of het leveren van de gevraagde dienst.",
  ] },
  { h: "5. Bewaring", p: [
    "Persoonsgegevens worden uitsluitend bewaard gedurende de periode die nodig is voor de doeleinden waarvoor ze werden verzameld en, in voorkomend geval, gedurende de termijnen vereist door Belgische wettelijke of administratieve verplichtingen.",
  ] },
  { h: "6. Uw rechten", p: [
    "Overeenkomstig de AVG beschikt u met name over de volgende rechten: recht op inzage, verbetering, wissing, beperking van de verwerking, bezwaar en overdraagbaarheid van uw gegevens.",
    "Elk verzoek met betrekking tot uw persoonsgegevens kan worden gericht aan info@vplus.be. U heeft eveneens het recht een klacht in te dienen bij de Belgische Gegevensbeschermingsautoriteit.",
  ] },
  { h: "7. Beveiliging", p: [
    "Er worden redelijke technische en organisatorische maatregelen genomen om uw persoonsgegevens te beschermen tegen ongeoorloofde toegang, verlies of gebruik.",
  ] },
  { h: "8. Updates", p: [
    "Dit privacybeleid kan worden bijgewerkt wanneer dat nodig is. De op de website gepubliceerde versie is van toepassing.",
  ] },
];

export default function Confidentialite() {
  const { lang } = useLang();
  const isFr = lang !== "nl";
  const sections = isFr ? FR : NL;

  return (
    <div data-testid="politique-confidentialite">
      <PageHeader
        overline={isFr ? "Protection des données" : "Gegevensbescherming"}
        title={isFr ? "Politique de confidentialité" : "Privacybeleid"}
      />
      <div className="max-w-3xl mx-auto px-6 md:px-12 pb-20 md:pb-28 space-y-11">
        {sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight mb-4">{s.h}</h2>
            {s.p.map((para, i) => (
              <p key={i} className="text-white/55 font-light leading-relaxed mb-3">{para}</p>
            ))}
            {s.list && (
              <ul className="space-y-1.5 text-white/70 font-light mt-1">
                {s.list.map((l, i) => <li key={i}>{l}</li>)}
              </ul>
            )}
            {s.bullets && (
              <ul className="mt-2 space-y-2">
                {s.bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/55 font-light leading-relaxed">
                    <span className="mt-2 w-1 h-1 rounded-full bg-accent-yellow shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
